import './Register.scss';
import WhiteGreenWrapper from '../../wrappers/WhiteGreenWrapper';
import { RegisterStepType } from './RegisterForm';
import Header from '@/components/Header/Header';
import { useTranslation } from 'react-i18next';
import { RolesEnum } from '@/core/enums';
import PageTitle from '@/components/PageTitle';
import RegisterFormAmazonConnex from './RegisterFormAmazonConnex';
import RightImage from '@/images/register-amazon-connex.svg';
import TipIcon from '@/icons/tip-blue-circle.svg?react';

interface Props {
  initialStep?: RegisterStepType;
  initialEmail?: string;
  initialPassword?: string;
  role?: RolesEnum;
}

export default function RegisterAmazonConnex({
  initialStep,
  initialEmail,
  initialPassword,
  role,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className='flex min-h-screen flex-col'>
      <PageTitle title='Register' />
      <Header />
      <WhiteGreenWrapper
        className='WhiteGreenWrapper--Register'
        rightSideContent={
          <div>
            <div className='pt-1 text-center'>
              <img
                src={RightImage}
                alt='AmazonConnectImage'
                className='AmazonConnection__image'
              />
            </div>
            <div className='mt-4'>
              <div className='inline-flex rounded-lg bg-yellow-500 px-2 font-semibold text-dark-blue'>
                {t('Free during the beta phase!')}
              </div>
            </div>
            <div className='mb-2'>
              <div className='inline-flex rounded-lg bg-yellow-500 px-2 font-semibold text-dark-blue'>
                {t('What you get:')}
              </div>
            </div>
            <div className='space-y-2'>
              {[
                'Exports for your accounting in DATEV-compatible format',
                'Option to set up associated accounts',
                'Overview of your expenditure over the course of the year',
              ].map((text, index) => (
                <div key={index} className='flex items-start gap-x-2'>
                  <TipIcon className='mt-1 h-4 w-4 shrink-0 [&>circle]:fill-white [&>path]:fill-ink' />
                  <div>{t(text)}</div>
                </div>
              ))}
            </div>
          </div>
        }
      >
        <RegisterFormAmazonConnex
          initialStep={initialStep}
          initialEmail={initialEmail}
          initialPassword={initialPassword}
          role={role}
        />
      </WhiteGreenWrapper>
    </div>
  );
}
